import Warning from '~/errors/Warning';

class StorageError extends Warning {
    constructor(message: string) {
        super(message);
        this.productionMessage =
            'Không trích xuất được kho lưu trữ. Đây có thể là vấn đề liên quan đến trình duyệt hoặc quyền hạn. Vui lòng thử lại sau.';

        this.name = 'StorageError';
    }
}

export default StorageError;
